import { SurveyPreInterviewTemplate } from './preInterview/SurveyPreInterviewTemplate';

export const SurveySettings = (): JSX.Element => {
   return <SurveyPreInterviewTemplate />;
};
